import { createFileRoute } from "@tanstack/react-router";

import { ComposeWithAgent } from "../../workspaces/build/components/DesignWithAgent";
import { useProjectId } from "../../shell/project";

interface ComposeSearch {
  /** The platform body the robot designer starts from. */
  readonly from?: string;
}

export const Route = createFileRoute("/_console/p/$org/$project/robots/compose")({
  validateSearch: (search: Record<string, unknown>): ComposeSearch =>
    typeof search.from === "string" && search.from !== "" ? { from: search.from } : {},
  component: ComposeRoute,
});

/** A robot is composed by talking to the robot designer: this address opens that
 *  conversation, with the robot it starts from beside it. */
function ComposeRoute() {
  const projectId = useProjectId();
  const { from } = Route.useSearch();
  return <ComposeWithAgent projectId={projectId} from={from} />;
}
